import { Action, createReducer, on } from '@ngrx/store';
import { IsUserLockedRequest, IsUserLockedResponse } from '../models/lock.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { checkUserLockedRequest, checkUserLockedResponse, checkUserLockedFailure } from '../actions/locked.actions';

export const checkUserLockedFeatureKey = 'checkUserLocked';

export interface CheckLockedState {
  isLockedRequest: IsUserLockedRequest;
  isLockedResponse: IsUserLockedResponse;
  isLockedFailure: IGenericError<ErrorResponse>;
}

export const initialState: CheckLockedState = {
  isLockedRequest: undefined,
  isLockedResponse: undefined,
  isLockedFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(checkUserLockedRequest, (state, action) => ({
    ...state,
    isLockedRequest: action.request
  })),
  on(checkUserLockedResponse, (state, action) => ({
    ...state,
    isLockedResponse: action.response
  })),
  on(checkUserLockedFailure, (state, action) => ({
    ...state,
    isLockedFailure: action.error
  }))
);

export const getCheckUserLockedRequest = (state: CheckLockedState) => state.isLockedRequest;
export const getCheckLockedResponse = (state: CheckLockedState) => {
  return state.isLockedResponse;
};
export const getCheckLockedFailure = (state: CheckLockedState) => state.isLockedFailure;
